import React, { createContext, useContext } from 'react';
import brand from '../brandConfig';

const BrandContext = createContext(brand);

export function BrandProvider({ children }) {
  return (
    <BrandContext.Provider value={brand}>
      {children}
    </BrandContext.Provider>
  );
}

export function useBrand() {
  return useContext(BrandContext);
}
